import { render, staticRenderFns } from "./auto-message-summary-card.vue?vue&type=template&id=d03fe13c&scoped=true&"
import script from "./auto-message-summary-card.vue?vue&type=script&lang=js&"
export * from "./auto-message-summary-card.vue?vue&type=script&lang=js&"
import style0 from "./auto-message-summary-card.vue?vue&type=style&index=0&id=d03fe13c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03fe13c",
  null
  
)

export default component.exports